// Product page interaction functionality
document.addEventListener('DOMContentLoaded', function() {
  console.log('Initializing product interactions...');
  
  // Share button functionality
  initializeShareButton();
  
  // Heart button functionality
  initializeWishlistButton();
  
  // Quantity selector 
  initializeQuantitySelector();
  
  console.log('Product interactions initialized');
});

function initializeShareButton() {
  const shareButton = document.getElementById('shareButton');
  const shareDropdown = document.getElementById('shareDropdown');
  
  if (shareButton && shareDropdown) {
    // Remove any existing event listeners by cloning the button
    const newShareButton = shareButton.cloneNode(true);
    shareButton.parentNode.replaceChild(newShareButton, shareButton);
    
    // Re-get the button reference after cloning
    const currentShareButton = document.getElementById('shareButton');
    
    console.log('Initializing share button'); // Debug log
    
    currentShareButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      console.log('Share button clicked'); // Debug log
      
      if (shareDropdown.classList.contains('active')) {
        closeShareDropdown();
      } else {
        openShareDropdown();
      }
    });
    
    // Add touch event for mobile
    currentShareButton.addEventListener('touchend', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      console.log('Share button touched'); // Debug log
      
      if (shareDropdown.classList.contains('active')) {
        closeShareDropdown();
      } else {
        openShareDropdown();
      }
    });
    
    // Functions to handle dropdown state
    function openShareDropdown() {
      console.log('Opening share dropdown'); // Debug log
      
      // Make dropdown visible first
      shareDropdown.style.display = 'flex';
      shareDropdown.style.opacity = '0';
      
      // Small delay to ensure display is applied
      setTimeout(() => {
        // Position the dropdown
        const buttonRect = currentShareButton.getBoundingClientRect();
        const isMobile = window.innerWidth < 768;
        
        if (isMobile) {
          // Mobile: Position to the left of the button
          const dropdownWidth = shareDropdown.offsetWidth || 200;
          shareDropdown.style.top = buttonRect.top + 'px';
          shareDropdown.style.left = (buttonRect.left - dropdownWidth - 10) + 'px';
          shareDropdown.style.transform = 'none';
          shareDropdown.classList.add('dropdown-left');
          shareDropdown.classList.remove('dropdown-above', 'dropdown-below');
        } else {
          // Desktop: Position below or above based on space
          const spaceBelow = window.innerHeight - buttonRect.bottom;
          const spaceAbove = buttonRect.top;
          
          if (spaceBelow < 250 && spaceAbove > spaceBelow) {
            // Show above
            shareDropdown.style.top = (buttonRect.top - shareDropdown.offsetHeight - 10) + 'px';
            shareDropdown.classList.add('dropdown-above');
            shareDropdown.classList.remove('dropdown-below', 'dropdown-left');
          } else {
            // Show below
            shareDropdown.style.top = (buttonRect.bottom + 10) + 'px';
            shareDropdown.classList.add('dropdown-below');
            shareDropdown.classList.remove('dropdown-above', 'dropdown-left');
          }
          
          // Center horizontally relative to button
          shareDropdown.style.left = (buttonRect.left + (buttonRect.width / 2)) + 'px';
          shareDropdown.style.transform = 'translateX(-50%)';
        }
        
        // Add active class and fade in
        shareDropdown.classList.add('active');
        shareDropdown.style.opacity = '1';
        
        // Update button visual state
        currentShareButton.classList.add('share-btn-active');
        currentShareButton.setAttribute('aria-expanded', 'true');
        
        // Set timeout to avoid immediate closing
        setTimeout(function() {
          document.addEventListener('click', handleOutsideClick);
          document.addEventListener('touchend', handleOutsideClick);
        }, 100);
      }, 10);
    }
    
    function closeShareDropdown() {
      console.log('Closing share dropdown'); // Debug log
      
      shareDropdown.style.display = 'none';
      shareDropdown.style.opacity = '0';
      shareDropdown.classList.remove('active');
      
      // Update button visual state
      currentShareButton.classList.remove('share-btn-active');
      currentShareButton.setAttribute('aria-expanded', 'false');
      
      document.removeEventListener('click', handleOutsideClick);
      document.removeEventListener('touchend', handleOutsideClick);
    }
    
    function handleOutsideClick(event) {
      if (!currentShareButton.contains(event.target) && !shareDropdown.contains(event.target)) {
        closeShareDropdown();
      }
    }
  }
}

function initializeWishlistButton() {
  var heartBtn = document.querySelector('.heart-btn');
  
  if (heartBtn) {
    // Function to update button visuals
    const updateHeartVisuals = function(active) {
      if (active) {
        heartBtn.classList.add('heart-active');
        const heartSvg = heartBtn.querySelector('svg');
        if (heartSvg) {
          heartSvg.setAttribute('fill', '#e74c3c');
          heartSvg.setAttribute('stroke', '#e74c3c');
        }
      } else {
        heartBtn.classList.remove('heart-active');
        const heartSvg = heartBtn.querySelector('svg');
        if (heartSvg) {
          heartSvg.setAttribute('fill', 'none');
          heartSvg.setAttribute('stroke', 'currentColor');
        }
      }
    };
    
    // Check wishlist status on page load
    if (window.SwymCallbacks && typeof window._swat !== 'undefined') {
      window.SwymCallbacks = window.SwymCallbacks || [];
      window.SwymCallbacks.push(function(swat) {
        var productId = heartBtn.getAttribute('data-product-id');
        var productHandle = heartBtn.getAttribute('data-product-handle');
        
        try {
          swat.api.fetch(function(products) {
            if (!products) return;
            
            var isInWishlist = products.filter(function(item) {
              return item.empi == productId || (item.du && item.du.includes(productHandle));
            }).length > 0;
            
            updateHeartVisuals(isInWishlist);
          });
        } catch (e) {
          console.log("Error checking wishlist status:", e);
        }
      });
    }
    
    // Handle wishlist toggling
    heartBtn.addEventListener('click', function() {
      var productId = this.getAttribute('data-product-id');
      var inWishlist = this.classList.contains('heart-active');
      
      // Toggle visual state immediately for good UX
      updateHeartVisuals(!inWishlist);
      
      // Process in backend
      if (!inWishlist) {
        addToWishlist(productId, this);
      } else {
        removeFromWishlist(productId, this);
      }
    });
    
    function addToWishlist(productId, button) {
      try {
        // Try to find and click the swym button first
        var swymButton = document.querySelector('.swym-button, .swym-add-to-wishlist, [class*="swym-add-to-wishlist"], [id*="swym-add-to-wishlist"]');
        if (swymButton) {
          swymButton.click();
          return;
        }
        
        // Use Swym API directly if available
        if (window._swat) {
          var productData = {
            epi: productId,
            du: window.location.href,
            empi: productId,
            pr: button.getAttribute('data-product-price') || "0.00",
            stk: 1,
            iu: button.getAttribute('data-product-image') || "",
            dt: button.getAttribute('data-product-title') || "Product"
          };
          
          window._swat.addToWishList(productData);
        }
      } catch (e) {
        console.log("Error adding to wishlist:", e);
      }
    }
    
    function removeFromWishlist(productId, button) {
      try {
        if (window._swat) {
          window._swat.removeFromWishList({
            epi: productId,
            du: window.location.href
          });
        }
      } catch (e) {
        console.log("Error removing from wishlist:", e);
      }
    }
  }
}

function initializeQuantitySelector() {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.minusButton = this.querySelector('button[name="minus"]');
      this.plusButton = this.querySelector('button[name="plus"]');

      if (!this.input || !this.minusButton || !this.plusButton) return;

      // Bind methods to this instance
      this.handleButtonClick = this.handleButtonClick.bind(this);
      this.handleInputChange = this.handleInputChange.bind(this);
      this.handleKeyDown = this.handleKeyDown.bind(this);

      // Add event listeners
      this.minusButton.addEventListener('click', this.handleButtonClick);
      this.plusButton.addEventListener('click', this.handleButtonClick);
      this.input.addEventListener('change', this.handleInputChange);
      this.input.addEventListener('keydown', this.handleKeyDown);

      // Prevent scrolling when using mousewheel on the input
      this.input.addEventListener('wheel', (e) => {
        e.preventDefault();
      }, { passive: false });
    }

    handleButtonClick(event) {
      event.preventDefault();
      const isPlus = event.currentTarget.name === 'plus';
      const currentValue = parseInt(this.input.value, 10) || 1;
      const newValue = isPlus ? currentValue + 1 : Math.max(1, currentValue - 1);
      
      if (this.input.value !== String(newValue)) {
        this.input.value = newValue;
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    handleInputChange(event) {
      const value = parseInt(event.target.value, 10);
      const newValue = Math.max(1, isNaN(value) ? 1 : value);
      
      if (this.input.value !== String(newValue)) {
        this.input.value = newValue;
      }
    }

    handleKeyDown(event) {
      if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
        event.preventDefault();
        const isUp = event.key === 'ArrowUp';
        const currentValue = parseInt(this.input.value, 10) || 1;
        const newValue = isUp ? currentValue + 1 : Math.max(1, currentValue - 1);
        
        if (this.input.value !== String(newValue)) {
          this.input.value = newValue;
          this.input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
  }

  // Only define the custom element if it hasn't been defined yet
  if (!customElements.get('quantity-input')) {
    customElements.define('quantity-input', QuantityInput);
  }
}
